import { Helmet } from 'react-helmet-async';

const PageSEO = ({ title, description, path = '' }) => {
  const siteName = 'VE PERA İnşaat';
  const baseUrl = 'https://veperainsaat.com';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | Güvenli Yapılar, Değerli Yaşam Alanları`;
  const fullUrl = `${baseUrl}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="tr_TR" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default PageSEO;
